<template>
  <v-container name="tanfolyamok-component">

    <v-row justify="end">
      <v-radio-group v-model="picked" row>
        <v-radio label="Aktív" color="#FF9800" value="false"></v-radio>
        <v-radio label="Archív" color="#FF9800" value="true" ></v-radio>
      </v-radio-group>
    </v-row>

    <v-row>
      <v-container>
      <v-text-field
        v-model="tanfolyam_search_text"
        @keyup.enter="fetchCourses()"
        ref="search"
        label="Tanfolyamok keresése"
        outlined
        clearable
        prepend-inner-icon="search"
      ></v-text-field>
      </v-container>
    </v-row>

  <div id="diakok_result">
    <center>
      <v-progress-circular
      :size="70"
      :width="7"
      color="red"
      indeterminate
      v-if="preloader"
    ></v-progress-circular>
    <div v-show="courses" style="width: 98%;">

      <v-card>
        <v-card-title>
            Tanfolyamok
      </v-card-title>

      <v-data-table
      v-if="courses"
      :headers="courses_header"
      :items="courses"
      :mobile-breakpoint='NaN'
      sort-by="course_start"
      sort-desc
      >
      <template v-slot:item="{ item }">
        <tr>
        <td style='min-width: 150px'>{{item.course_number}}</td>
        <td style='min-width: 130px'>{{item.course_start}}</td>
        <td style='min-width: 120px'>{{item.course_end}}</td>
        <td style='min-width: 100px'>{{item.nkh_category}}</td>
        <td style='min-width: 150px'>{{item.name}}</td>
        <td style='min-width: 160px'>{{item.place_name}}</td>
        <td style='min-width: 130px'>{{item.count}} / {{item.preg_count}}</td>
        <td>
          <v-btn
            class="ma-2"
            outlined small fab
            color="primary"
            @click="fetchCourseDetails(item.course_id,item.driving_school_id,item.course_number,item.course_start,item.course_end,item.course_type,item.course_type_id,item.course_pattern,item.place_name,item.training_place_id)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </td>
        </tr>
      </template>
      </v-data-table>
      </v-card>

    </div>
  </center>
  </div>

  <v-snackbar v-model="archive_course_snackbar" bottom>
    {{archive_course_result}}
    {{tanrend_lemond}}
    <v-btn color="pink" text @click="archive_course_snackbar = false">
      Bezár
    </v-btn>
  </v-snackbar>

  </v-container>
</template>

<script>
import store from '../store'
import { mapFields } from 'vuex-map-fields'

  export default {
    data() {
      return {
        courses_header: [
          { text: 'Tanfolyam száma', value: 'course_number'},
          { text: 'Kezdés', value: 'course_start' },
          { text: 'Befejezés', value: 'course_end' },
          { text: 'Kategória', value: 'course_type' },
          { text: 'Tanfolyam sablon', value: 'name' },
          { text: 'Helyszín', value: 'place_name' },
          { text: 'Létszám', value: 'count' },
          { text: ''},
        ],
        courses: '',
        tanfolyam_search_text: '',
        error_text: '',
        student_details: '',
        picked: 'false',
        archive_course_snackbar: false,
        tanrend_lemond: '',
        archive_course_result: '',
      }
    },
    methods: {
      fetchCourses: async function() {
        this.courses = ''
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/tanfolyamok_list', {
          token: this.token,
          tanfolyam_search_text: this.tanfolyam_search_text,
          archived: this.picked,
        }).then((response) => {
          store.state.showing.preloader = false
          this.courses = response.data

        }, (error) => {
          this.error_text = error.data
        })
      },
      fetchCourseDetails(course_id,driving_school_id,course_number,course_start,course_end,course_type,course_type_id,course_pattern,place_name,training_place_id) {
        this.course_id = null
        this.course_id = course_id
        this.driving_school_id = null
        this.driving_school_id = driving_school_id
        this.course_number = null
        this.course_number = course_number
        this.course_start = null
        this.course_start = course_start
        this.course_end = null
        this.course_end = course_end
        this.course_type = null
        this.course_type = course_type
        this.course_type_id = null
        this.course_type_id = course_type_id
        this.course_pattern = null
        this.course_pattern = course_pattern
        this.place_name = null
        this.place_name = place_name
        this.place_id = null
        this.place_id = training_place_id
        this.TanfolyamokDetails_show = true
        this.Tanfolyamok_show = false
      },
    },
    mounted() {
      this.fetchCourses()
    },
    updated() {

    },
    created() {
      this.$eventBus.$on('archive_course_result', (data) => {
      this.archive_course_result = data['archive_result']
      this.tanrend_lemond = data['result']
      this.archive_course_snackbar = true
      });
    },
    watch: {
      Diakok_show: function (value) {
        if (value == true) {
          this.fetchStudents()
        }
      },
      Tanfolyamok_show: function (value) {
        if (value == true) {
          this.fetchCourses()
        }
      },
      picked: function (value) {
          this.course_id = null;
          this.fetchCourses()
      },
    },
    computed: {
    ...mapFields([
    'tanfolyamok.course_id',
    'tanfolyamok.course_number',
    'tanfolyamok.course_start',
    'tanfolyamok.course_end',
    'tanfolyamok.place_name',
    'tanfolyamok.place_id',
    'tanfolyamok.course_type',
    'tanfolyamok.course_type_id',
    'tanfolyamok.course_pattern',
    'tanfolyamok.driving_school_id',
    'showing.TanfolyamokDetails_show',
    'showing.Tanfolyamok_show',
    'showing.preloader',
  ]),
  },
  }
</script>

<style lang="css">
</style>
